export const parameters = {
	serviceUrl: 'https://briisk-i-uat-api.azure-api.net/bl',
	captchaKey: '6LeeTsMrAAAAANEOVxC4fMXdXZX2yzABk9SdvhsA',
	brandLabelSubscriptionKey: 'c39f3e284f68434e93a0dfdf0eb6b867',
	bitpUrl: 'https://briisk-i-uat-web.azurewebsites.net',
	environment: ''

	// serviceUrl: 'http://localhost:7071',
	// serviceUrl: 'https://briisk-i-dev-api.azure-api.net/bl',
	// captchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	// brandLabelSubscriptionKey: '6aeeca623d274b61bd75b25cd28d2cb8',
	// bitpUrl: 'https://briisk-i-dev-web.azurewebsites.net',
	// environment: 'dev'
};
